import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { Breadcrumb } from "rsuite";
import { GarageDetailCard } from "../../components";
import CustomLoader from "../../components/loader";
import { generateUUID } from "../../helpers/guid";
import garageCart from "../../redux/garageCart";
import { GarageCartItem } from "../../redux/garageCart/type";
import { getLocalized } from "../../redux/localization";
import { getOfferDetails, getOfferDocuments } from "../../redux/offer";
import { UploadDocumentInput } from "../../redux/offer/types";
import SummaryCard from "../garage/summary-card";
import DocumentForm from "./document-form";

const OfferGaragePage = () => {
  const localize = useSelector(getLocalized);
  const location = useLocation();
  const [garageCartObject, setGarageCartObject] = useState<GarageCartItem[]>(
    []
  );
  const garageCartRef = useRef<GarageCartItem[]>([]);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [documents, setdocuments] = useState<UploadDocumentInput[]>([]);
  const { Id }: { Id: string } = useParams();
  useEffect(() => {
    setLoader(true);

    const queryObject = new URLSearchParams(location.search);
    dispatch(
      getOfferDocuments({
        payload: {
          onSuccess: (message, payload) => {
            const array: UploadDocumentInput[] = [];
            payload.map((document) =>
              array.push({
                Id: document.Id,
                DocumentTypeName: document.DemandedDocument,
                DocumentFile: "",
              })
            );
            setdocuments(array);
            array.length > 0
              ? dispatch(
                  getOfferDetails({
                    payload: {
                      onSuccess: (message, payload) => {
                        console.log(payload, "payload");
                        let array: GarageCartItem[] = [];
                        payload.OfferCars?.map((offerCar) => {
                          const data: GarageCartItem = {
                            Id: generateUUID(),
                            Car: offerCar,
                            ExtraServices: [],
                            Insurance: false,
                            Count: offerCar.Quantity ? offerCar.Quantity : 0,
                            Price: {
                              CarId: offerCar.Id,
                              PeriodId: offerCar.PeriodId
                                ? offerCar.PeriodId
                                : "",
                              KMLimitId: offerCar.KMLimitId
                                ? offerCar.KMLimitId
                                : "",
                              PricePerMonth: offerCar.PeriodPrice
                                ? offerCar.PeriodPrice
                                : 0,
                              KMLimitPerYear: offerCar.KMLimit
                                ? offerCar.KMLimit
                                : 0,
                              PeriodCount: offerCar.Period
                                ? offerCar.Period
                                : 0,
                            },
                          };
                          return array.push(data);
                        });
                        garageCartRef.current = array;
                        setGarageCartObject(array);
                        setLoader(false);
                        return dispatch(
                          garageCart.actions.addListToGarage(array)
                        );
                      },
                      onError: (message) => {},
                    },
                    url: "api/offer/" + Id,
                  })
                )
              : setLoader(false);
          },
          onError: (message) => {},
        },
        url:
          "api/offer/demandeddocument/documentstoupload/" +
          queryObject.get("documentIds[]"),
      })
    );
    // eslint-disable-next-line
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        paddingBlockEnd: 90,
      }}
    >
      <div className="container" style={{ marginBlockStart: 19 }}>
        <div className="w-100 d-flex justify-content-between my-2">
          <h2 className="header-font">
            <div className="breadcrumb">
              <Breadcrumb>
                <Breadcrumb.Item href="/" className="breadCrumbText">
                  {localize.getString("home")}
                </Breadcrumb.Item>
                <Breadcrumb.Item href="/cars" className="breadCrumbText">
                  {localize.getString("allcars")}
                </Breadcrumb.Item>
                <Breadcrumb.Item active className="breadCrumbText">
                  {localize.getString("cardetail")}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </h2>
        </div>
        <div
          className="divider-div garage-content"
          style={{ marginBlockStart: 15 }}
        >
          <div>
            {loader && <CustomLoader />}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {documents.length > 0 && <DocumentForm documents={documents} />}
            </div>
            {garageCartRef.current.map((garageCartItem, i) => (
              <GarageDetailCard
                isDetail
                key={i}
                setLoader={setLoader}
                data={garageCartItem}
              />
            ))}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div>
              <SummaryCard isCreate={false} data={garageCartObject} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OfferGaragePage;
